'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _contextTypes = require('./contextTypes');

var _contextTypes2 = _interopRequireDefault(_contextTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `TableBody` component is used for managing the state of all
 * `TableRow` inside of it.
 */
var TableBody = function (_Component) {
  _inherits(TableBody, _Component);

  function TableBody() {
    _classCallCheck(this, TableBody);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TableBody.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var selectedRows = this.context.selectedRows;


    var rows = children ? _react.Children.map(_react.Children.toArray(children), function (row, i) {
      var uncontrolled = typeof row.props.selected === 'undefined';
      return _react2.default.cloneElement(row, {
        selected: uncontrolled ? selectedRows[i] : row.props.selected
      });
    }) : null;

    return _react2.default.createElement(
      'tbody',
      _extends({}, props, { className: (0, _classnames2.default)('md-table-body', className) }),
      rows
    );
  };

  return TableBody;
}(_react.Component);

TableBody.propTypes = {
  /**
   * An optional style to apply to the tbody.
   */
  style: _propTypes2.default.object,

  /**
   * An optional className to apply to the tbody.
   */
  className: _propTypes2.default.string,

  /**
   * A list or a single item of `TableRow` components to render.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)])
};
TableBody.contextTypes = _contextTypes2.default;
exports.default = TableBody;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/DataTables/TableBody.js
// module id = 853
// module chunks = 213534597649335